import buildMeta from '../utils/buildMeta'

const routes = [
  {
    path: '/login',
    redirect: to => '/auth/login',
  },
  {
    path: '/signup',
    redirect: to => '/auth/signup',
  },
  {
    name: 'auth',
    path: '/auth',
    component: () => import('@/pages/Auth/Auth.vue'),
    meta: buildMeta({
      authRequired: false,
      redirectIfAuthenticated: true,
      hideDistractions: true,
      robots: null,
      title: 'Jobscan Log In, Sign In - Jobscan',
      description:
        'Welcome back to Jobscan! Log in to access your full profile and Jobscan dashboard.',
    }),
    children: [
      {
        name: 'logIn',
        path: 'login',
        component: () => import('@/pages/Auth/components/AuthForm.vue'),
        meta: buildMeta({
          authRequired: false,
          redirectIfAuthenticated: true,
          hideDistractions: true,
          robots: null,
          title: 'Jobscan Log In, Sign In - Jobscan',
          description:
            'Welcome back to Jobscan! Log in to access your full profile and Jobscan dashboard.',
        }),
      },
      {
        name: 'signUp',
        path: 'signup',
        component: () => import('@/pages/Auth/components/AuthForm.vue'),
        meta: buildMeta({
          authRequired: false,
          redirectIfAuthenticated: true,
          hideDistractions: true,
          robots: null,
          title: 'Create Account - Try Jobscan for Free - Jobscan',
          description:
            'Welcome to Jobscan! Register with us to save your profile information, scan history, and access your dashboard.',
        }),
      },
      {
        name: 'ssoLogin',
        path: 'sso/:domain/login',
        component: () => import('@/pages/Auth/components/SSOLogin.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          robots: null,
          title: 'Jobscan Log In, Sign In - Jobscan',
        }),
      },
    ],
  },
  {
    name: 'forgot-password',
    path: '/forgot-password',
    component: () => import('@/pages/Password/ForgotPassword.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      robots: null,
      title: 'Reset Password - Jobscan',
      description: 'Reset your password to log in to Jobscan.',
    }),
  },
  {
    name: 'password-reset-sent',
    path: '/password-reset-sent',
    component: () => import('@/pages/Password/PasswordResetSent.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      title: 'Password Reset - Jobscan',
    }),
  },
  {
    name: 'reset-password',
    path: '/reset-password',
    component: () => import('@/pages/Password/CreateNewPassword.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      title: 'Password Reset - Jobscan',
    }),
  },
  {
    name: 'password-changed',
    path: '/password-changed',
    component: () => import('@/pages/Password/PasswordChanged.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      title: 'Password Changed - Jobscan',
    }),
  },
  {
    name: 'verify-email',
    path: '/verify-email',
    component: () => import('@/pages/Email/EmailVerification.vue'),
    meta: buildMeta({
      authRequired: true,
      hideDistractions: true,
      title: 'Email Verified - Jobscan',
      description: 'Verify your email address to continue using Jobscan.',
    }),
  },
]

export default routes
